<template>
  <div class="public-content gathering">
    <div class="breadcrumb">收款统计</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="是否校验:">
              <el-select v-model="formInline.checked" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option label="已校验" :value="true"></el-option>
                <el-option label="未校验" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态:">
              <el-select v-model="formInline.equalZero" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option label="已平账" :value="true"></el-option>
                <el-option label="未平账" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="true" align="left" unlink-panels range-separator="至"
                start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="onSubmit(1)" round>查询</el-button>
            <el-button class="search-ok" @click="exportExcel" round>导出Excel</el-button>
            <el-button class="search-ok" @click="flatAccount" round type="primary">平账</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" :row-class-name="rowClassName" row-key="statsId" @selection-change="handleSelectionChange" border style="width: 100%">
          <el-table-column type="selection" reserve-selection></el-table-column>
          <el-table-column prop="paymentDate" label="支付日期" min-width="10px"></el-table-column>
          <el-table-column prop="amountCharge" label="充值总金额" min-width="10">
            <template v-slot="scope"><span v-if='$hasPermission("epay:admin:chargeStats:amountCharge")'>{{ scope.row.amountCharge }}</span><span v-else>*</span></template>
          </el-table-column>
          <el-table-column prop="amountBank" label="实际收款总额" min-width="10"></el-table-column>
          <el-table-column label="收款差" min-width="10">
            <template v-slot="scope">
              <span v-show="scope.row.checked"> {{ Savings(+scope.row.amountBank - scope.row.amountCharge) }}</span>
              <span v-show="!scope.row.checked"> *</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="10"></el-table-column>
          <el-table-column label="状态" min-width="10">
            <template v-slot="scope"> {{ scope.row.balancingAccount ? '已平账' : '未平账' }} </template>
          </el-table-column>
          <el-table-column label="是否校验" min-width="10px">
            <template v-slot="scope">
              <span :class="{ 'color-blue': !scope.row.checked }" v-if="$hasPermission('epay:admin:chargeStats:modify')"
                @click="scope.row.checked ? '' : dialogVisible = true, checkBox.id = scope.row.statsId, amountCharge = scope.row.amountCharge">{{ scope.row.checked ? '已校验' : '未校验' }}</span>
              <span v-else></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" @changePage="changePage" :queryInfo='queryInfo'></v-pagination>
    </div>
    <CombinedDialog ref="dialogRef" @changeVerify="getVerify"></CombinedDialog>
    <!-- 未校验弹窗 -->
    <el-dialog :close-on-click-modal="false" title="收款校验：" :visible.sync="dialogVisible" @closed="checkBox.vo = { amount: null, remark: null }" width="30%">
      <el-form ref="form" :rules="rulesOfCheckBox" :model="checkBox.vo" label-width="100px">
        <el-form-item label="收款金额：" prop="amount">
          <el-input style="width:80%" v-model="checkBox.vo.amount" clearable type="number"></el-input>
        </el-form-item>
        <el-form-item label="金额提示：">
          <div>{{ convertCurrency }}</div>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" style="width:80%" v-model="checkBox.vo.remark" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="check" style="float: right;margin-left: 10px;">确定</el-button>
          <el-button @click="dialogVisible = false" style="float: right;">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import CombinedDialog from '@/components/Dialog/CombinedDialog/index.vue'
import { chargeStatsPage, chargeStatsCheck, statsBalancingAccount, statsExport } from '@/api/epay'
export default {
  name: 'VpayChargeStats',
  components: {
    VPagination,
    CombinedDialog
  },
  inject: ['reload'],
  data () {
    var amount = (rule, value, callback) => {
      if (!this.checkBox.vo.amount) {
        callback(new Error('请输入收款金额'))
      } else if (!/^([0-9]+[\d]*(.[0-9]{1,2})?)$/.test(this.checkBox.vo.amount)) {
        callback(new Error('请输入小数点后最长两位的数字'))
      } else {
        callback()
      }
    }
    return {
      amountCharge: 0, // 收款校验的时候用
      multipleSelection: [],
      checkBox: {
        id: '',
        vo: {
          amount: null,
          remark: null
        }
      },
      rulesOfCheckBox: {
        amount: [
          { validator: amount, trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      formInline: {
        checked: '',
        dateEnd: '',
        dateStart: '',
        equalZero: ''
      },
      tableData: [{
        amountBank: '',
        amountCharge: '',
        checked: '',
        datePayment: '',
        index: '',
        remark: '',
        equalZero: ''
      }],
      value2: [
        this.$moment().subtract(6, 'months').format('YYYY-MM-DD'),
        this.$moment().format('YYYY-MM-DD')
      ],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      gridData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海'
      }]
    }
  },
  watch: {
    value2: {
      handler (val, oldVal) {
        console.log(val)
        if (val) {
          this.formInline.dateStart = val[0]
          this.formInline.dateEnd = val[1]
        } else {
          this.formInline.dateStart = ''
          this.formInline.dateEnd = ''
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    convertCurrency () {
      return this.$convertCurrency(this.checkBox.vo.amount)
    },
    Savings () {
      return (val) => {
        return val.toFixed(2)
      }
    }
  },
  created () {
    if (this.$route.query.checked === 'false') {
      this.formInline.checked = false
    } else if (this.$route.query.checked === 'true' && this.$route.query.equalZero === 'false') {
      this.formInline.checked = true
      this.formInline.equalZero = false
    }
    this.onSubmit()
  },
  methods: {
    // 未校验
    check () {
      if (this.checkBox.vo.amount !== this.amountCharge && !this.checkBox.vo.remark) {
        this.$message.warning('收款金额与充值金额不符，请填写备注')
        return
      }
      if (parseInt(this.checkBox.vo.amount) > 1000000) {
        this.$message.warning('收款金额不能大于1000000')
        return
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        console.log(this.checkBox)
        chargeStatsCheck(this.checkBox).then(res => {
          if (res.data.success) {
            this.$message.success('已校验')
            this.onSubmit()
            this.dialogVisible = false
          }
        })
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    onSubmit (num) {
      this.queryInfo.pageNum = num || this.queryInfo.pageNum
      chargeStatsPage({ data: this.formInline, params: { page: this.queryInfo.pageNum - 1, size: this.queryInfo.pageSize } }).then((res) => {
        this.tableData = res.data.data.content
        this.queryInfo.total = res.data.data.total
      })
    },
    getOrderStatus (val) {
      if (!val.verify.flag) {
        this.$refs.dialogRef.show('verify', '收款校验', '', '', val.index)
      }
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let param = JSON.parse(JSON.stringify(this.formInline))
      // if (param.dateStart === '') {
      //   param.dateStart = this.$moment().subtract(1, 'months').format('YYYY-MM-DD')
      //   param.dateEnd = this.$moment().format('YYYY-MM-DD')
      // }
      Object.keys(param).forEach((key) => (param[key] === '' || param[key] === null) && delete param[key])
      statsExport(param).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          let _fileName = '收款统计表' + '.xls'
          if (param.dateStart && param.dateEnd) _fileName = '收款统计表' + param.dateStart + '-' + param.dateEnd + '.xls'
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    getVerify (val) {
      this.tableData[val.index].account = val.message
      this.tableData[val.index].remark = val.labelTitle
    },
    flatAccount () {
      if (this.multipleSelection.length < 2) {
        this.$message.error('至少选两个')
        return
      }
      let ids = []
      this.multipleSelection.forEach(item => {
        ids.push(item.statsId)
      })
      statsBalancingAccount({ ids }).then(res => {
        if (res.data.success) {
          this.$message.success('已平账')
        }
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log('this.multipleSelection', this.multipleSelection)
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
// @import "index";
@deep: ~">>>";
</style>
